import React, { FC } from 'react';
import { Link } from 'react-router-dom';

/** Serif "Bhabi ♠" wordmark used by every account / auth top bar. */
export const BhabiWordmark: FC<{ to?: string; label?: string }> = ({
  to = '/',
  label = 'Bhabi home',
}) => (
  <Link to={to} className="bh-brand" aria-label={label}>
    Bhabi
    <span className="bh-brand__pip" aria-hidden="true">
      ♠
    </span>
  </Link>
);
